<div [class]="_class">
  <input #input [type]="_type" [attr.list]="list" [autocomplete]="autocomplete" [placeholder]="placeholder"
    aria-label="input" [value]="_value" [class.prefix]="!!prefixIcon" [class.suffix]="!!suffixIcon"
    (change)="onChange($event)" (keydown)="preventIlegalCharacters($event)" (keyup)="onChange($event)" [attr.data-test]="testAttribute">
  <div>
    <lib-icon *ngIf="prefixIcon" [name]="prefixIcon"></lib-icon>
    <span class="lib-spacer" role="none"></span>
    <lib-icon *ngIf="suffixIcon" [name]="suffixIcon"></lib-icon>
  </div>
</div>
